import NotificationTileApl from './NotificationTileApl';
export default NotificationTileApl;
